<template>
  <div>
    <v-row v-show="!isCardExpanded">
      <v-col cols="4">
        <management-card-group type="transhipmentOnTime" is-transhipment />
      </v-col>
      <v-col cols="4">
        <management-card-group type="transhipmentCritical" is-transhipment />
      </v-col>
      <v-col cols="4">
        <management-card-group type="transhipmentLate" is-transhipment />
      </v-col>
    </v-row>
    <v-row v-show="isCardExpanded" class="py-0 my-0">
      <v-col class="py-0 my-0"> <expanded-management-card /> </v-col
    ></v-row>
  </div>
</template>

<script>
import ManagementCardGroup from './ManagementCardGroup.vue';
import ExpandedManagementCard from './ExpandedTranshipmentManagementCard.vue';
import { ExpandedTranshipmentManagementCardHandler } from '@/store/modules/expandedTranshipmentManagementCard';
export default {
  components: {
    ManagementCardGroup,
    ExpandedManagementCard
  },
  computed: {
    isCardExpanded() {
      return ExpandedTranshipmentManagementCardHandler.getIsCardExpanded(this);
    }
  }
};
</script>

<style></style>
